import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';

import * as propertyPicture from '../actions/property-picture';
import { PropertyPictureService } from '../services/property-picture-http.service';
import { IGalleryItem } from '../../common/models/gallery-item';

@Injectable()
export class PropertyPictureEffects {

  constructor(
    private actions$: Actions,
    private propertyPictureService: PropertyPictureService) {
  }

  
  upload$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<propertyPicture.Upload>(propertyPicture.UPLOAD),
    switchMap(action => {
      return this.propertyPictureService.postImage(action.context, action.files).pipe(
        map(() => new propertyPicture.UploadComplete(action.context.PropertyRef, action.files)),
        catchError(err => of(new propertyPicture.UploadError(err)))
      );
    })));

  
  load$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<propertyPicture.Load>(propertyPicture.LOAD),
    switchMap(action => {
      return this.propertyPictureService.getImagesByProperty(action.propertyRef).pipe(
        map((payload: IGalleryItem[]) => new propertyPicture.LoadComplete(payload)),
        catchError(err => of(new propertyPicture.LoadError(err)))
      );
    })));

  
  uploadComplete$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<propertyPicture.UploadComplete>(propertyPicture.UPLOAD_COMPLETE),
    switchMap(action => [new propertyPicture.Load(action.propertyRef)])
  ));

  
  delete$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<propertyPicture.Delete>(propertyPicture.DELETE),
    switchMap(action => {
      return this.propertyPictureService.deleteImage(action.documentKey).pipe(
        map(res => new propertyPicture.DeleteComplete(action.documentKey, action.propertyRef, action.fileName)),
        catchError(err => of(new propertyPicture.DeleteError(action.documentKey, action.fileName, err)))
      );
    })));

  
  deleteComplete$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<propertyPicture.DeleteComplete>(propertyPicture.DELETE_COMPLETE),
    switchMap(action => [new propertyPicture.Load(action.propertyRef)])));

}
